/**
 * Fonctionnalités du reader, activables par application (ChatNovel, MySmartBook).
 *
 * Miroir de `ReaderFeatures` côté Kotlin (reader commun) : mêmes noms, mêmes règles,
 * pour que Web, desktop et mobile se comportent de la même façon.
 */
export const defaultFeatures = {
    chat: "smartbook-only",
    contextualChat: true,
    explain: true,
    highlights: true,
    notes: true,
    recap: true,
    talkWith: true,
    quiz: true,
    aroundMe: true,
    search: true,
    // Comme l'app : proposée pour tous les livres recomposables.
    tts: true,
    accessibilityPreferences: true,
};
/** Configuration par marque. À aligner sur la répartition validée côté produit. */
export const brandFeatures = {
    mysmartbook: { ...defaultFeatures, chat: "smartbook-only" },
    chatnovel: { ...defaultFeatures, chat: "all" },
};
export function isChatAvailable(features, book, accessMode) {
    if (accessMode === "excerpt")
        return false;
    switch (features.chat) {
        case "none":
            return false;
        case "smartbook-only":
            return book.isSmartbook;
        case "all":
            return true;
    }
}
/**
 * Fonctionnalités effectivement disponibles pour une ouverture donnée.
 * En mode extrait, seules la lecture et les préférences restent actives.
 */
export function effectiveFeatures(features, book, accessMode) {
    const chatAvailable = isChatAvailable(features, book, accessMode);
    if (accessMode === "excerpt") {
        return {
            ...features,
            chat: "none",
            contextualChat: false,
            explain: false,
            highlights: false,
            notes: false,
            recap: false,
            talkWith: false,
            quiz: false,
            aroundMe: false,
        };
    }
    return {
        ...features,
        contextualChat: features.contextualChat && chatAvailable,
    };
}
/** Surcharge partielle (flag distant, test A/B) appliquée à une configuration de marque. */
export function withOverrides(features, overrides) {
    return { ...features, ...overrides };
}
/**
 * Fonctionnalités de l'application retenues pour un livre, comme Studio : `null` ou `undefined` (décisions
 * inconnues, API muette) laissent ce qui ne dépend pas du livre et coupent ce qui n'existe qu'avec son accord.
 */
export function withBookDecisions(features, decisions) {
    return {
        ...features,
        // Défini pour tous les livres côté serveur : seul un refus explicite le coupe.
        explain: features.explain && decisions?.explain_passage !== false,
        recap: features.recap && decisions?.summary_no_spoiler === true,
        talkWith: features.talkWith && decisions?.talk_with === true,
        quiz: features.quiz && decisions?.quiz === true,
        aroundMe: features.aroundMe && decisions?.around_me === true,
    };
}
//# sourceMappingURL=features.js.map